import Rectangle from "./Rectangle";
import Length from "./Length";
import AbstractShape from "./AbstractShape";
import Area from "./Area";

export default class Jewel extends AbstractShape {
	static NAME = "jewel";

	constructor( width_top, width_bottom, height_top, height_bottom ) {
		super();

		this.width_top = width_top;
		this.width_bottom = width_bottom;
		this.height_top = height_top;
		this.height_bottom = height_bottom;
	}

	get_name() {
		return Jewel.NAME;
	}

	get_enclosing_rectangle() {
		return new Rectangle( this.get_width(), this.get_height() );
	}

	/**
	 * Calculate the total area of the jewel shape, which consiss of a bottom
	 * isosceles trangle and a top trapezoid.
	 */
	get_area() {
		const width_top = this.get_width_top().in_mm();
		const width_bottom = this.get_width_bottom().in_mm();
		const height_top = this.get_height_top().in_mm();
		const height_bottom = this.get_height_bottom().in_mm();

		const bottom_triangle = width_bottom * height_bottom / 2;
		const top_trapezoid = ( width_top + width_bottom ) / 2 * height_top;

		return new Area( bottom_triangle + top_trapezoid );
	}

	/**
	 * Calculate the circumference of the shape, by calculating the angled side
	 * lengths for both the triangle and trapezoid, and adding the top width.
	 */
	get_circumference() {
		const width_top = this.get_width_top().in_mm();
		const width_bottom = this.get_width_bottom().in_mm();
		const height_top = this.get_height_top().in_mm();
		const height_bottom = this.get_height_bottom().in_mm();

		const triangle_side_length = Math.sqrt( Math.pow( width_bottom / 2, 2 ) + Math.pow( height_bottom, 2 ) );
		const trapezoid_side_length = Math.sqrt( Math.pow( ( width_bottom - width_top ) / 2, 2 ) + Math.pow( height_top, 2 ) );

		return new Length( triangle_side_length * 2 + trapezoid_side_length * 2 + width_top );
	}

	get_width() {
		return this.width_bottom;
	}

	get_height() {
		return this.height_top.add( this.height_bottom );
	}

	get_width_top() {
		return this.width_top;
	}

	get_width_bottom() {
		return this.width_bottom;
	}

	get_height_top() {
		return this.height_top;
	}

	get_height_bottom() {
		return this.height_bottom;
	}

	get_maximum_dimensions( maximum_rectangle ) {
		const longest_side = maximum_rectangle.get_longest_side();
		const height_top = longest_side.divide( 3 ).in_mm();
		const height_bottom = height_top + ( height_top / 2 );

		return {
			width_top: maximum_rectangle.get_shortest_side(),
			width_bottom: maximum_rectangle.get_shortest_side(),
			height_top: new Length( height_top ),
			height_bottom: new Length( height_bottom ),
		};
	}

	get_dimension_keys() {
		return [ "width_top", "width_bottom", "height_top", "height_bottom" ];
	}

	get_modifier_keys() {
		return [];
	}

	serialize_primitives() {
		return {
			width_top: this.width_top.in_mm(),
			width_bottom: this.width_bottom.in_mm(),
			height_top: this.height_top.in_mm(),
			height_bottom: this.height_bottom.in_mm()
		};
	}

	static deserialize_primitives( primitives ) {
		return new Jewel(
			new Length( primitives.width_top ),
			new Length( primitives.width_bottom ),
			new Length( primitives.height_top ),
			new Length( primitives.height_bottom )
		);
	}

}
